import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";
import AxiosInterceptor from "../../Services/examinterceptor";

const createSchoolDetails = async (payload) => {
  const { url, body } = payload;
  const result = await AxiosInterceptor.post(url, body);
  return result;
};

const createStudentDetails = async (payload) => {
  const { url, body } = payload;
  const result = await AxiosInterceptor.post(url, body);
  return result;
};

export function* SCHOOLCREATESAGA() {
  yield takeEvery(actions.SCHOOL_CREATE_REQUEST, function* ({ payload }) {
    try {
      const res = yield call(createSchoolDetails, payload);
      if (res.data.status_code === 1) {
        yield put({
          type: actions.SCHOOL_CREATE_SUCCESS,
          message: res?.data?.message,
        });
      } else {
        yield put({
          type: actions.SCHOOL_CREATE_ERROR,
          message: res?.data?.message,
          error: "Failed to create school. Please try again.",
        });
      }
    } catch (error) {
      yield put({
        type: actions.SCHOOL_CREATE_ERROR,
        error: error?.response?.data?.message,
      });
    }
  });
}

export function* STUDENTCREATESAGA() {
  yield takeEvery(actions.STUDENT_CREATE_REQUEST, function* ({ payload }) {
    try {
      const res = yield call(createStudentDetails, payload);
      if (res.data.status_code === 1) {
        yield put({
          type: actions.STUDENT_CREATE_SUCCESS,
          message: res?.data?.message,
          status_code: res?.data?.status_code,
        });
      } else {
        yield put({
          type: actions.STUDENT_CREATE_ERROR,
          error: "Failed to create student. Please try again.",
          message: res?.data?.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.STUDENT_CREATE_ERROR,
        error: error?.response?.data?.message || "An error occurred.",
      });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(SCHOOLCREATESAGA),fork(STUDENTCREATESAGA)]);
}
